module.exports = __webpack_public_path__ + "media/partners/mars-82047a7f.svg";